export default {
      id: "i-arrow-left-usage",
      viewBox: "0 0 529 238",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-left",
      toString: function () {
        return this.url;
      }
    }